const getSetupFeeFromRelatedItems = relatedItems => Math.max(...relatedItems.map(({
  setupFee
}) => setupFee));
export default getSetupFeeFromRelatedItems;